import type { StatsData } from '../../../AnalyticsCard.types'

export const getMaxValueFromStatsData = (data: StatsData[]): number => {
  if (!data || data.length === 0) {
    return 0
  }

  return Math.max(
    ...data.flatMap((item) => {
      if (Array.isArray(item.value)) {
        return item.value
      }

      return [item.value]
    }),
  )
}
